import { forwardRef } from 'react'

import { Dayjs } from 'dayjs'
import dayjsGenerateConfig from 'rc-picker/lib/generate/dayjs'
import generatePicker from 'antd/es/date-picker/generatePicker'
import { DatePickerProps } from 'antd'
import enUS from 'antd/es/date-picker/locale/en_US'
import styled from 'styled-components'
import { PickerRef } from 'rc-picker'

import RightIcon from 'src/Assets/Svg/pages-icons/RightArrow.svg?react'

const AntdDatePicker = generatePicker<Dayjs>(dayjsGenerateConfig)

const FULL_MONTH_DATE_PICKER_LOCALE = {
  ...enUS,
  lang: {
    ...enUS.lang,
    monthFormat: 'MMMM',
  },
}

const StyledPrevIcon = styled(RightIcon)`
  transform: rotate(180deg);
`

const CustomDatePicker = forwardRef<PickerRef, DatePickerProps>(
  ({ className, locale, ...rest }, ref) => (
    <AntdDatePicker
      nextIcon={<RightIcon />}
      prevIcon={<StyledPrevIcon />}
      popupClassName={className}
      prefixCls='date-picker'
      locale={{
        ...FULL_MONTH_DATE_PICKER_LOCALE,
        ...locale,
        lang: {
          ...FULL_MONTH_DATE_PICKER_LOCALE.lang,
          ...locale?.lang,
          monthFormat: 'MMMM',
        },
      }}
      ref={ref}
      {...rest}
    />
  ),
)

export const PrimaryDatePicker = styled(CustomDatePicker)`
  z-index: 1000 !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;

  &.date-picker-dropdown .date-picker-date-panel .date-picker-body {
    padding: 0 16px;
  }
  &.date-picker-dropdown .date-picker-header-view > button {
    line-height: 150%;
    &:hover {
      color: ${({ theme }) => theme.color.darkGrey};
    }
  }

  &.date-picker-dropdown .date-picker-header-view {
    color: ${({ theme }) => theme.color.darkGrey};
    font-family: 'Segoe UI';
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 150%;
  }
  &.date-picker-dropdown .date-picker-panel-container {
    border-radius: 16px;
    border: 1px solid ${({ theme }) => theme.color.lightGrey};
    background: ${({ theme }) => theme.color.white};
    box-shadow: ${({ theme }) => theme.shadow.header};
  }

  &.date-picker-dropdown .date-picker-header {
    padding: 16px 16px;
    border-bottom: none;
  }

  &.date-picker-dropdown .date-picker-ranges {
    padding: 16px 16px;
  }
  &.date-picker-dropdown .date-picker-header > button {
    min-width: fit-content;
    color: ${({ theme }) => theme.color.darkGrey};
  }
  .date-picker-super-prev-icon,
  .date-picker-super-next-icon {
    display: none;
  }
  .date-picker-content thead tr th {
    font-family: 'Segoe UI';
    color: ${({ theme }) => theme.color.darkGrey};
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
  }
  &.date-picker-dropdown
    .date-picker-cell-in-view.date-picker-cell-selected:not(
      .date-picker-cell-disabled
    )
    .date-picker-cell-inner {
    border-radius: 8px;
    background: ${({ theme }) => theme.color.brandGreen};
    color: ${({ theme }) => theme.color.white};
    font-family: 'Segoe UI';
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
  }
  &.date-picker-dropdown .date-picker-cell {
    font-family: 'Segoe UI';
    color: ${({ theme }) => theme.color.darkGrey};
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
  }
  &.date-picker-dropdown .date-picker-cell-in-view {
    color: ${({ theme }) => theme.color.darkGrey};
    font-family: 'Segoe UI';
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
  }
  &.date-picker-dropdown
    .date-picker-cell-in-view.date-picker-cell-today
    .date-picker-cell-inner::before {
    border-radius: 8px;
    border: 1px solid ${({ theme }) => theme.color.brandGreen};
  }
  &.date-picker-dropdown .date-picker-ranges .date-picker-ok {
    margin: 0 auto;
  }
  &.date-picker-dropdown .date-picker-cell-disabled::before {
    background: ${({ theme }) => theme.color.lightGrey};
  }
`
